var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user"},[_c('div',{staticClass:"info"},[_c('a',[_vm._v(" "+_vm._s(_vm.user.nickname)+" ")]),_c('div',{staticClass:"clearfix"})])])}
var staticRenderFns = []

export { render, staticRenderFns }